import { ConfigTypes } from 'src/AppState/ConfigState/types';

export const features: ConfigTypes = {
    /* A */
    anniversaryInfoShow: false,
    accountTradingCountryClub: false,
    accountTradingDragonCircle: false,
    accountTradingRewardZone: false,
    accountTradingTartanClub: false,
    affiliateIdPromoCode: false,
    activityTimeframe: false,

    /* B */
    betBuilderReferralSwitchShow: true,

    /* C */
    casinoProviders: {
        casino: ['leap', 'pragmatic', 'blueprint', 'relax', 'evolution'],
        'live-casino': ['pragmatic', 'evolution'],
        virtuals: ['pragmatic', 'leap'],
    },
    closureCodes: true,
    cmsHiddenTabs: ['headlineCarousel', 'promoCode'],
    complianceRestrictionSummary: false,
    complianceNew: true,
    contactPreferences: {
        preferences: ['email', 'sms', 'phone'],
        options: ['betting', 'casino'],
        newMarketing: true,
    },
    currencies: ['GBP', 'EUR', 'XTS'], // TODO: CONFIRM FOR BETWRIGHT
    cpfProperties: false,
    casinoStoreEnabled: false,

    /* D */
    dashboardTab: false,
    decimalLength: 2,
    depositLimitType: 'rollingType',
    depositLimitCalculationTypeConfigurable: false,
    depositRestriction: true,
    deceased: false,

    /* E */
    externalId: false,

    /* F */
    configurationManagerUI: false,
    failedWithdrawalsFundsEnabled: true,
    footerContentDefault: {
        description_text: '#TOBEADDED', // TODO: ADD FOR BETWRIGHT
        licence_number: '#TOBEADDED', // TODO: ADD FOR BETWRIGHT
        licence_url: '#TOBEADDED', // TODO: ADD FOR BETWRIGHT
        cookies_url: '#TOBEADDED', // TODO: ADD FOR BETWRIGHT
        has_cookies: true,
    },
    footerLegalTextTab: true,
    fullNameProperties: false,

    /* H */
    hasNewMenu: true,
    hideDeleteImageButtonOnHomePageCarousel: false,
    hasXtremepush: false,

    /* G */
    gamprotect: false,
    gamstopNew: true,
    gamstopPpBlockedSuspendedActions: false,
    golfOnVirtuals: false,
    gtm: '', // TODO: ADD FOR BETWRIGHT

    /* I */
    isAffordability: true,
    isPEP: true,
    identity: true,
    idMission: false,
    isBoostedPriceAvailable: true,
    indexNow: null,

    /* L */
    languages: [
        {
            value: 'en',
            label: 'English',
        },
    ],

    /* O */
    operatorFullName: 'BetWright',

    /* P */
    personalId: false,
    paymentSearchWalletAddress: false,
    pof: true,
    promotionHistoryEnabled: true,

    /* R */
    realityCheckLimitedType: false,
    reportDownloadOptions: ['Export to CSV'],
    redirectToNewBetTickerPage: false,
    redirectToNewCMSPage: false,
    reportsV2: false,
    redirectToNewTradingPage: false,
    showRingFencedFunds: true,

    /* M */
    markersOfHarm: true,
    mobilePrefixDisabled: false,
    dopplernegroPrefix: false,
    minDepositAmount: '1',
    minWithdrawAmount: '1',
    minManualAdjustmentAmount: '1',

    /* N */
    newPragmatic: true,
    newPofSrg: true,
    notificationSounds: {
        newChat: 'ding',
        newBetReferral: 'ding',
    },

    /* S */
    sourceOfFunds: true,
    srgEnabled: true,
    starEventsLabel: 'BetWright Specials', // TODO: CONFIRM FOR BETWRIGHT
    showBonusEngine: true,
    showNewCustomerSettings: false,
    showRABInputs: true,
    showBonusCreator: false,

    /* T */
    tableauDashboards: true,
    tagManagementTab: true,
    topEvents: true,

    /* U */
    usePaymentFormForUniverse: {
        type: 'paysafe',
        apiKey: 'T1QtMzM0ODIyOkItcDEtMC02NjFmYTljYS0wLTMwMmMwMjE0MWM5N2QyMzI2NzhkMzZhMjQ3ZDcxYWUxZTUwOTUyMjhiNDZlMjkzYTAyMTQ1OTM2ZmJkMmVjZmFjMmE3ODE3YmQ1YTY5ZGEyNzFmZTE0MjA3YzRj',
        environment: 'LIVE',
        cardAccounts: {
            GBP: '1002968952',
            EUR: '',
        },
        openBanking: null,
    },
    userTitleOptional: false,
    /* V */

    /* W */
    withdrawalsTabsShow: true,
    withdrawalStandardLimit: '5000',
    workbookView: {
        BackofficeReports: 'BackOfficeReports-BetWright/DB-Casino',
        AccountBalances: 'AccountBalances-BetWright/AccountBalances',
        CasinoDashboard: 'CasinoDashboard-BetWright/CasinoMainDashboard',
        ComplianceDashboard: 'ComplianceDashboard-BetWright/ComplianceMainDashboard',
        MarketingDashboard: 'MarketingDashboard-BetWright/MarketingMainDashboard',
        ProfitAndLossKPIs: 'ProfitandLossKPIs-BetWright/DailyKPI',
        RacecourseDashboard: 'RacecourseDashboard-BetWright/RacecourseMediaGroupDashboard',
        TransactionsDashboard: 'TransactionsDashboard-BetWright/TransactionsMainDashboard',
        RollingNetDeposits: 'RollingNetDeposits-BetWright/RollingNetDeposits',
        PlatformOverview: 'Overview-BetWright/Overview',
        BonusEngine: 'BonusEngine-BetWright/CampaignLevel',
    },
};
